export const ADVANCE_TIMEFRAME_OPTIONS = [
    { value: 'pay-period', label: 'pay cycle' },
    { value: 'month', label: 'month' },
    { value: 'week', label: 'week' },
    { value: 'day', label: 'day' }
];
